import { createRouter, createWebHistory } from 'vue-router'

const history = createWebHistory()

const router = createRouter({
  history,
  routes: [
    {
      path: '/h5/verifyuser',
      name: 'VerifyUser',
      component: () => import('@/pages/verifyUser/index.vue'),
      meta: {
        title: '手机号码',
      },
    },
    {
      path: '/h5/verifyid',
      name: 'VerifyID',
      component: () => import('@/pages/verifyId/index.vue'),
      meta: {
        title: '身份证件',
      },
    },
    {
      path: '/h5/verifyresult',
      name: 'VerifyResult',
      component: () => import('@/pages/verifyResult/index.vue'),
      meta: {
        title: '验证结果',
      },
    },
    {
      // 姓名身份证二要素验证
      path: '/h5/nameid',
      name: 'nameIdCard',
      component: () => import('@/pages/nameIdCard/index.vue'),
      meta: {
        title: '实名认证',
      },
    },
    // Linked Accounts
    {
      path: '/h5/relatedcccount',
      name: 'relatedAccount',
      component: () => import('@/pages/relatedAccount/index.vue'),
      meta: {
        title: '关联账号',
      },
    },
  ],
})
router.beforeEach((to, _from, next) => {
  if (Object.prototype.hasOwnProperty.call(to.meta, 'title')) {
    const { title } = to.meta
    // let subTitle = null
    // if (Object.prototype.hasOwnProperty.call(to.meta, 'subTitle')) {
    //   subTitle = to.meta.subTitle
    // }
    document.title = title as string
    // if (subTitle && jssdk) {
    //   jssdk.ui.setHeader({ title, subTitle })
    // }
  }
  next()
})
export default router
